import { useMemo } from 'react'

import { useLeasingSeasonsList } from '../../containers/LeasingSeason/hooks/useLeasingSeasonQueries'
import { resolveEffectiveCurrentSeasonId } from '../../containers/LeasingSeason/utils/seasonSelection'
import { useUser } from '../useUser'

export type GuestCardChannelDefaults = {
    walk_in: number | null
    campaign: number | null
    website: number | null
}

const EMPTY_DEFAULTS: GuestCardChannelDefaults = {
    walk_in: null,
    campaign: null,
    website: null,
}

function parseChannelId(value: unknown): number | null {
    if (value == null || value === '') return null
    const n = typeof value === 'number' ? value : Number(value)
    return Number.isFinite(n) ? n : null
}

function channelsFromSeason(
    channels: Record<string, unknown> | null | undefined,
): GuestCardChannelDefaults {
    if (!channels) return { ...EMPTY_DEFAULTS }
    return {
        walk_in: parseChannelId(channels.walk_in),
        campaign: parseChannelId(channels.campaign),
        website: parseChannelId(channels.website),
    }
}

/**
 * Guest card ids pinned on a season's Guest Card pack.
 * Walk-in uses this card. Campaign / website are defaults only.
 */
export function useGuestCardChannelDefaults(seasonId?: number | null) {
    const { workspaceUser } = useUser()
    const apartmentId = workspaceUser?.active_workspace?.id

    const seasonsQuery = useLeasingSeasonsList(apartmentId)
    const seasons = seasonsQuery.data ?? []
    const resolvedSeasonId =
        seasonId ?? resolveEffectiveCurrentSeasonId(seasons)
    const season = seasons.find((item) => item.id === resolvedSeasonId) ?? null

    const defaults = useMemo(
        () => channelsFromSeason(season?.guest_card_channels),
        [season?.guest_card_channels],
    )

    return {
        defaults,
        isLoading: seasonsQuery.isLoading,
        currentSeasonId: resolvedSeasonId,
        leasingSeasonConfigId: season?.leasing_season_config_id ?? null,
    }
}
